import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './helper/App';
import reportWebVitals from './helper/reportWebVitals';
import swDev from "./helper/swDev"
import {setupAxios} from "./network/setupAxios";
import axios from "axios";
import store, {persistor} from "./helper/redux/store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {runAppBuildMigration} from "./helper/appBuild";

if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
}

async function bootstrap() {
    const didMigrate = await runAppBuildMigration();
    if (didMigrate) {
        // Full page reload is in progress; skip mounting the old/new hybrid tree.
        return;
    }

    setupAxios(axios, store);

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <App/>
                </PersistGate>
            </Provider>
        </React.StrictMode>
    );

    swDev();
    reportWebVitals();
}

bootstrap();
